import React from "react";
import DateHelper from '../DateHelper/DateHelper';
import { format } from 'date-fns';

class CurrentTime extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      current: DateHelper.current(this.props.time_zone_offset)
    };

    this.updateCurrent = this.updateCurrent.bind(this);
  };

  componentDidMount() {
    this.interval = setInterval(this.updateCurrent, 1000)
  };

  componentWillUnmount() {
    clearInterval(this.interval)
  };

  render() {
    if(this.props.printOneLine){
      return(
        <div className="CurrentTime modal-footer-clock">
          <span>{format(this.state.current, DateHelper.rubyToDateFNS(this.props.date_format))}; </span>
          <span>{format(this.state.current, DateHelper.rubyToDateFNS(this.props.time_format))}{' '} </span>
          <span>{ this.props.time_zone } </span>
        </div>
      );
    } else {
      return (
        <div>
          {format(this.state.current, DateHelper.rubyToDateFNS(this.props.date_format))}
          <br />
          {format(this.state.current, DateHelper.rubyToDateFNS(this.props.time_format))}{' '}
          <br />
          {this.props.time_zone}
        </div>
      );
    };
  };

  /**
  * Helper functions
  */

  updateCurrent() {
    this.setState({current: DateHelper.current(this.props.time_zone_offset)})
  };

};

export default CurrentTime;